// src/components/layout/Sidebar.js
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useEncomendasAuth } from '../../context/EncomendasContext';
import { db, paths } from '../../firebase/config';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

// --- Ícones ---
const ReportsIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>);
const SoeIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>);
const DashboardIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>);
const GerenciadorIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>);
const AdminIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826 3.31 2.37-2.37.996.608 2.296.096 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>);
const ProfessorIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>);
const MateriasIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>);
const EscalanteIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>);
const CadeteIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>);
const NotasIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>);
const LogoutIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>);
const AspirantometroIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>);
const CmtPelotaoIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6" /></svg>);
const EncomendasIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-1.414 1.414a1 1 0 01-.707.293H10.414a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 007.586 13H4" /></svg>);
const ClockIcon = () => <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const StarIcon = () => (<svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>);
const UserAddIcon = () => <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /></svg>;
const ChartPieIcon = () => (
  <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
  </svg>
);
const CheckSquareIcon = () => (
    <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);
const GlobeIcon = () => (
  <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
  </svg>
);

const ChevronDownIcon = () => (<svg className="w-4 h-4 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>);
const ChevronUpIcon = () => (<svg className="w-4 h-4 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>);

const SidebarLink = ({ to, icon, label, onClick }) => (
  <NavLink
    to={to}
    end 
    className={({ isActive }) =>
      `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
        isActive
          ? 'bg-blue-600 text-white'
          : 'text-gray-300 hover:bg-gray-700 hover:text-white'
      }`
    }
    onClick={onClick} 
  >
    {icon}
    <span className="font-medium">{label}</span>
  </NavLink>
);

export const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const { userProfile, logoutApp, isAdmin, isEscalante, isCadete, isGerenciador, isSoe, isCmtPelotao, isCadeteAcademico } = useAuth();
  const { isAuthorized: isEncomendasAuthorized, isLoading: isLoadingEncomendas } = useEncomendasAuth();
  
  const isProfessor = userProfile?.nivel === 'professor'; 
  const isCmtCia = userProfile?.nivel === 'cmt_cia'; 
  const isLiderEO = userProfile?.isLiderEO === true;

  const navigate = useNavigate();
  
  const [hasPendingEvaluations, setHasPendingEvaluations] = useState(false);
  const [isEstagiosMenuOpen, setIsEstagiosMenuOpen] = useState(false);
  const [isResultadoOnlineMenuOpen, setIsResultadoOnlineMenuOpen] = useState(false);
  const [isPainelEstagiosMenuOpen, setIsPainelEstagiosMenuOpen] = useState(false);
  const [isEstatisticasMenuOpen, setIsEstatisticasMenuOpen] = useState(false);
  const [isSistemasMenuOpen, setIsSistemasMenuOpen] = useState(false);
  const [isDiversosMenuOpen, setIsDiversosMenuOpen] = useState(false);

  useEffect(() => {
    const isDesktop = window.innerWidth >= 1024;
    if (isDesktop && !isSidebarOpen) {
      toggleSidebar(); 
    }
  }, [isSidebarOpen, toggleSidebar]);

  const handleLogout = () => { logoutApp(); navigate('/login'); };

  const handleLinkClick = () => {
    const isDesktop = window.innerWidth >= 1024;
    if (isDesktop) return; 
    toggleSidebar(); 
  };

  useEffect(() => {
    if (!userProfile || !userProfile.turma_id) {
        setHasPendingEvaluations(false);
        return;
    }

    const isAluno = isCadete || isCadeteAcademico || isEscalante;

    if (isAluno) {
        const collectionCiclos = paths.avaliacoesCiclos || 'artifacts/app-estagios/public/data/avaliacoesCiclos';
        const qCiclos = query(
            collection(db, collectionCiclos),
            where("turma_id", "==", userProfile.turma_id),
            where("ativo", "==", true)
        );

        const collectionRespostas = paths.avaliacoesRespostas || 'artifacts/app-estagios/public/data/avaliacoesRespostas';
        const qRespostas = query(
            collection(db, collectionRespostas),
            where("cadete_id", "==", userProfile.id)
        );

        let activeCycles = [];
        let userAnswers = [];

        const checkPending = () => {
            if (activeCycles.length === 0) {
                setHasPendingEvaluations(false);
                return;
            }
            let existsPending = false;
            for (const ciclo of activeCycles) {
                const profsDoCiclo = ciclo.professores_ids || [];
                for (const profId of profsDoCiclo) {
                    const jaRespondeu = userAnswers.some(a => a.ciclo_id === ciclo.id && a.professor_id === profId);
                    if (!jaRespondeu) {
                        existsPending = true;
                        break;
                    }
                }
                if (existsPending) break;
            }
            setHasPendingEvaluations(existsPending);
        };

        const unsubCiclos = onSnapshot(qCiclos, (snap) => {
            activeCycles = snap.docs.map(d => ({id: d.id, ...d.data()}));
            checkPending();
        });

        const unsubRespostas = onSnapshot(qRespostas, (snap) => {
            userAnswers = snap.docs.map(d => d.data());
            checkPending();
        });

        return () => {
            unsubCiclos();
            unsubRespostas();
        };
    } else {
        setHasPendingEvaluations(false);
    }
  }, [userProfile, isCadete, isCadeteAcademico, isEscalante]);

  return (
    <>
      <div className={`fixed inset-0 z-30 bg-black opacity-50 transition-opacity lg:hidden ${isSidebarOpen ? 'block' : 'hidden'}`} onClick={toggleSidebar}></div>
      
      <aside id="logo-sidebar" className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} bg-gray-900 text-white`} aria-label="Sidebar">
        <div className="h-full px-3 pb-4 overflow-y-auto bg-gray-900 flex flex-col space-y-4">
          <nav className="flex-1 space-y-2 pt-4">
            
            {isAdmin ? (
              <>
                 <SidebarLink to="/admin" icon={<AdminIcon />} label="Admin Painel" onClick={handleLinkClick} />
                 <SidebarLink to="/perfil-turmas" icon={<ChartPieIcon />} label="Perfil da Turma" onClick={handleLinkClick} />
              </>
            ) : isGerenciador ? (
              <>
                <SidebarLink to="/gerenciador" icon={<GerenciadorIcon />} label="Efetivo (Alocação)" onClick={handleLinkClick} />
                <SidebarLink to="/gerenciador/cadetes-cadastro" icon={<UserAddIcon />} label="Cadastro de Cadetes" onClick={handleLinkClick} />
                <SidebarLink to="/gerenciador/professores" icon={<ProfessorIcon />} label="Professores" onClick={handleLinkClick} />
                <SidebarLink to="/gerenciador/materias" icon={<MateriasIcon />} label="Grade Curricular" onClick={handleLinkClick} />
                <SidebarLink to="/gerenciador/cronograma" icon={<ClockIcon />} label="QTS Semanal" onClick={handleLinkClick} />
                <SidebarLink to="/gerenciador/avaliacoes" icon={<StarIcon />} label="Avaliar Instrutor" onClick={handleLinkClick} />
                <SidebarLink to="/perfil-turmas" icon={<ChartPieIcon />} label="Perfil da Turma" onClick={handleLinkClick} />
              </>
            ) : isSoe ? (
              <>
                  <SidebarLink to="/gerenciador/cadetes-cadastro" icon={<UserAddIcon />} label="Cadastro de Cadetes" onClick={handleLinkClick} />
                  
                  {/* --- MENU DROPDOWN ESTÁGIOS --- */}
                  <div>
                    <button
                      onClick={() => setIsEstagiosMenuOpen(!isEstagiosMenuOpen)}
                      className="flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors text-gray-300 hover:bg-gray-700 hover:text-white"
                    >
                      <div className="flex items-center space-x-3">
                        <SoeIcon />
                        <span className="font-medium">Gestão de Estágios</span>
                      </div>
                      {isEstagiosMenuOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </button>

                    {isEstagiosMenuOpen && (
                      <div className="bg-gray-800 rounded-b-lg mb-2 overflow-hidden">
                        <NavLink to="/soe" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Pesquisas e certidões</NavLink>
                        <NavLink to="/soe/relatorios" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Relatórios</NavLink>
                        <NavLink to="/soe/avaliacao-360" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Avaliação 360º</NavLink>
                      </div>
                    )}
                  </div>

                  <SidebarLink to="/painel-geral" icon={<DashboardIcon />} label="Dashboard Escola" onClick={handleLinkClick} />
                  <SidebarLink to="/perfil-turmas" icon={<ChartPieIcon />} label="Perfil das Turmas" onClick={handleLinkClick} />
              </>
            ) : isCmtCia ? (
              <>
                <SidebarLink to="/" icon={<DashboardIcon />} label="Dashboard Principal" onClick={handleLinkClick} />
                <SidebarLink to="/cmt-cia/estagio" icon={<EscalanteIcon />} label="Mapa de Estágio" onClick={handleLinkClick} />
                <SidebarLink to="/perfil-turmas" icon={<ChartPieIcon />} label="Perfil da Turma" onClick={handleLinkClick} />
              </>
            ) : isCmtPelotao ? (
              <>
                <SidebarLink to="/" icon={<DashboardIcon />} label="Dashboard" onClick={handleLinkClick} />
                <SidebarLink to="/cmt-pelotao" icon={<CmtPelotaoIcon />} label="Estágios" onClick={handleLinkClick} />
                <SidebarLink to="/perfil-turmas" icon={<ChartPieIcon />} label="Perfil da Turma" onClick={handleLinkClick} />
              </>
            ) : isProfessor ? (
              <>
                <SidebarLink to="/professor/disponibilidade" icon={<ClockIcon />} label="Minha Disponibilidade" onClick={handleLinkClick} />
              </>
            ) : (
              <>
                <SidebarLink to="/" icon={<DashboardIcon />} label="Dashboard" onClick={handleLinkClick} />
                
                {/* --- MENU DROPDOWN MÉTRICAS --- */}
                <div>
                  <button
                    onClick={() => setIsEstatisticasMenuOpen(!isEstatisticasMenuOpen)}
                    className="flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors text-gray-300 hover:bg-gray-700 hover:text-white"
                  >
                    <div className="flex items-center space-x-3">
                      <ChartPieIcon />
                      <span className="font-medium">Métricas</span>
                    </div>
                    {isEstatisticasMenuOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                  </button>
                  {isEstatisticasMenuOpen && (
                    <div className="bg-gray-800 rounded-b-lg mb-2 overflow-hidden">
                      <NavLink to="/aspirantometro" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Aspirantômetro</NavLink>
                      <NavLink to="/perfil-turmas" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Perfil da Turma</NavLink>
                    </div>
                  )}
                </div>

                {isEscalante ? (
                    <div>
                        <button
                          onClick={() => setIsPainelEstagiosMenuOpen(!isPainelEstagiosMenuOpen)}
                          className="flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors text-gray-300 hover:bg-gray-700 hover:text-white"
                        >
                          <div className="flex items-center space-x-3">
                            <EscalanteIcon />
                            <span className="font-medium">Escala e Estágios</span>
                          </div>
                          {isPainelEstagiosMenuOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                        </button>
                        {isPainelEstagiosMenuOpen && (
                          <div className="bg-gray-800 rounded-b-lg mb-2 overflow-hidden">
                            <NavLink to="/escalante" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Painel Escalante</NavLink>
                            <NavLink to="/cadete" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Estágios</NavLink>
                          </div>
                        )}
                    </div>
                ) : isCadeteAcademico ? (
                    <SidebarLink to="/cadete" icon={<CadeteIcon />} label="Estágios" onClick={handleLinkClick} />
                ) : null}
                
                {(isCadete || isCadeteAcademico || isEscalante) && hasPendingEvaluations && (
                    <SidebarLink to="/avaliacao-ensino" icon={<StarIcon />} label="Avaliação de Ensino" onClick={handleLinkClick} />
                )}

                {!isLoadingEncomendas && isEncomendasAuthorized && (<SidebarLink to="/encomendas" icon={<EncomendasIcon />} label="Encomendas" onClick={handleLinkClick} />)}
                <SidebarLink to="/notas" icon={<NotasIcon />} label="Classificação" onClick={handleLinkClick} /> 
                
                {isLiderEO ? (
                    <div>
                        <button
                          onClick={() => setIsResultadoOnlineMenuOpen(!isResultadoOnlineMenuOpen)}
                          className="flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors text-gray-300 hover:bg-gray-700 hover:text-white"
                        >
                          <div className="flex items-center space-x-3">
                            <CheckSquareIcon />
                            <span className="font-medium">Resultado Online</span>
                          </div>
                          {isResultadoOnlineMenuOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                        </button>
                        {isResultadoOnlineMenuOpen && (
                          <div className="bg-gray-800 rounded-b-lg mb-2 overflow-hidden">
                             <NavLink to="/resultado-online" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Lançar Resultado</NavLink>
                             <NavLink to="/lider-eo-config" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Configurar Revistas</NavLink>
                          </div>
                        )}
                    </div>
                ) : (
                    <SidebarLink to="/resultado-online" icon={<CheckSquareIcon />} label="Resultado Online" onClick={handleLinkClick} />
                )}
              </>
            )}

            {['cadete', 'cadete_academico', 'escalante', 'admin', 'cmt_cia', 'cmt_pelotao'].includes(userProfile?.nivel) && (
              <div>
                <button
                  onClick={() => setIsDiversosMenuOpen(!isDiversosMenuOpen)}
                  className="flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors text-gray-300 hover:bg-gray-700 hover:text-white"
                >
                  <div className="flex items-center space-x-3">
                    <svg className="w-6 h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    <span className="font-medium">Atribuições EO</span>
                  </div>
                  {isDiversosMenuOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </button>
                {isDiversosMenuOpen && (
                  <div className="bg-gray-800 rounded-b-lg mb-2 overflow-hidden">
                    <NavLink to="/livro-ordens" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Livro de Ordens</NavLink>
                  </div>
                )}
              </div>
            )}

            {!(isCmtPelotao || isCmtCia) && (
              <div>
                <button
                  onClick={() => setIsSistemasMenuOpen(!isSistemasMenuOpen)}
                  className="flex items-center justify-between w-full px-4 py-3 rounded-lg transition-colors text-gray-300 hover:bg-gray-700 hover:text-white"
                >
                  <div className="flex items-center space-x-3">
                    <GlobeIcon />
                    <span className="font-medium">Sistemas</span>
                  </div>
                  {isSistemasMenuOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </button>
                {isSistemasMenuOpen && (
                  <div className="bg-gray-800 rounded-b-lg mb-2 overflow-hidden">
                    <NavLink to="/resultado-apmbb" end onClick={handleLinkClick} className={({ isActive }) => `flex items-center space-x-3 px-4 py-2 pl-12 text-sm transition-colors ${isActive ? 'text-white font-bold bg-gray-700' : 'text-gray-400 hover:text-white hover:bg-gray-700'}`}>Escalas</NavLink>
                  </div>
                )}
              </div>
            )}
            
          </nav>

          <div className="border-t border-gray-700 pt-4">
            <button onClick={handleLogout} className="flex items-center space-x-3 w-full px-4 py-3 rounded-lg text-gray-300 hover:bg-red-600 hover:text-white">
              <LogoutIcon />
              <span className="font-medium">Sair</span>
            </button>
            <footer className="p-4 text-center">
              <p className="text-xs text-gray-500">© Asp 26 - Desenvolvido por Cadete Gonzaga v4.6.0</p>
            </footer>
          </div>
        </div>
      </aside>
    </>
  );
};